import React from 'react';
import { PropTypes as PT } from 'prop-types';
import ReactSpinner from 'react16-spinjs';
import { FormattedMessage } from 'react-intl';
import classes from './CalendarRefresh.module.scss';

class CalendarRefresh extends React.PureComponent {
  render() {
    const { updateTime, refresh, isRefreshing } = this.props;
    return (
      <div className={classes.container}>
        <div className={classes.updatedAt}>
          {updateTime && (
            <FormattedMessage
              id="components.calendarRefresh.updatedAt"
              defaultMessage="Updated at {time}"
              values={{ time: updateTime }}
            />
          )}
        </div>
        {isRefreshing ? (
          <div className={classes.refresh}>
            <ReactSpinner
              config={{
                lines: 13,
                length: 3,
                width: 3,
                radius: 5,
                color: '#4b45da',
                speed: 0.7
              }}
            />
          </div>
        ) : (
          <button className={classes.refresh} onClick={refresh}>
            <FormattedMessage id="components.calendarRefresh.refresh" defaultMessage="Refresh" />
          </button>
        )}
      </div>
    );
  }
}

CalendarRefresh.propTypes = {
  updateTime: PT.string,
  refresh: PT.func,
  isRefreshing: PT.bool
};

export default CalendarRefresh;
